import { PusatResolusiV2RequestInterface } from "../contracts/PusatResolusiV2Request";
import { MentionsData, RequestFinishForumPusatResolusi } from "@/domain/entities/PusatResolusiV2";
import {
  ConvertObjectCamelToSnakeCase,
  toFormDataUtils
} from "@/app/infrastructures/misc/Utils";
import { toFormDataUtilsV2 } from "@/app/infrastructures/misc/common-library/ToFormDataUtils";
import {
  QueryParamsEntities,
  QueryParamsEntitiesV3
} from "@/domain/entities/MainApp";
import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";

export class CheckTicketPusatResolusiRequest {
  refNo = "";
  type = "";
  categoryCode = "";
  desc = "";
  attachments: File[] = [];

  constructor(fields?: Partial<CheckTicketPusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }

  public toFormData() {
    return toFormDataUtilsV2(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class TicketCounterPusatResolusiRequest {
  ticketType = "";
  hubId = "";

  constructor(fields?: Partial<TicketCounterPusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class SendChatPusatResolusiRequest {
  message = "";
  mentions: any = [];
  attachments: File[] = [];

  constructor(fields?: Partial<SendChatPusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }

  public toFormData() {
    return toFormDataUtilsV2(this);
  }
}

export class FinishIssuePusatResolusiV2Request
  implements PusatResolusiV2RequestInterface {
  message = "";
  mentions: any = [];
  attachments: File[] = [];

  constructor(fields?: Partial<FinishIssuePusatResolusiV2Request>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }

  public toFormData() {
    return toFormDataUtilsV2(this);
  }
}
export class SubmitNotePusatResolusiRequest {
  id = 0;
  note = "";

  constructor(fields?: Partial<SubmitNotePusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return JSON.stringify({
      note: this.note
    });
  }
}

export class ListTicketPusatResolusiRequest {
  page = 1;
  limit = 10;
  ticketType = "";
  needToBeSolved = false;
  newMessage = false;
  mentioned = false;
  sortByDate = "";
  search = "";
  categoryIssueCode = "";
  statusTicket = "";
  ticketPriority = "";
  hubId = 0;

  constructor(fields?: Partial<ListTicketPusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class GetConversationRequest {
  beforeId = 0;
  limit = 20;

  constructor(fields?: Partial<GetConversationRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class ListSTTPusatResolusi {
  page = 1;
  limit = 10;

  constructor(fields?: Partial<ListSTTPusatResolusi>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}